// @flow

import isMatchWith from 'lodash/isMatchWith';
import {makeStripeRequest} from '../../StripeClui/helpers/commands/resource';

export default class ObjectHelpers {
  // This function was taken from StripeClui/helpers/commands/resource.js
  static normalizeParams = (params: {[string]: mixed}): {[string]: mixed} =>
    Object.fromEntries(
      Object.entries(params).map(([k, v]) => [k.replace(/-/g, '_'), v]),
    );

  static getEndpoint = (id: string) => {
    const prefix = id.split('_')[0];
    switch (prefix) {
      case 'ch':
        return 'charges';
      case 'cus':
        return 'customers';
      case 'dp':
        return 'disputes';
      case 'evt':
        return 'events';
      case 'file':
        return 'files';
      case 'link':
        return 'file_links';
      case 'po':
        return 'payouts';
      case 're':
        return 'refunds';
      case 'tok':
        return 'tokens';
      case 'pm':
        return 'payment_methods';
      case 'src':
        return 'sources';
      case 'prod':
        return 'products';
      case 'price':
        // Could also be 'plans'
        return 'prices';
      case 'promo':
        return 'promotion_codes';
      case 'txcd':
        return 'tax_codes';
      case 'txr':
        return 'tax_rates';
      case 'shr':
        return 'shipping_rates';
      case 'cs':
        return 'checkout/sessions';
      case 'plink':
        return 'payment_links';
      case 'cn':
        return 'credit_notes';
      case 'bpc':
        return 'billing_portal/configurations';
      case 'in':
        return 'invoices';
      case 'ii':
        return 'invoiceitems';
      case 'qt':
        return 'quotes';
      case 'sub':
        return 'subscriptions';
      case 'si':
        return 'subscription_items';
      case 'clock':
        return 'test_helpers/test_clocks';
      case 'acct':
        return 'accounts';
      case 'fee':
        return 'application_fees';
      case 'tu':
        return 'topups';
      default:
        return '';
    }
  };

  static fetchObject = async (id: string, apiKey: string, account: Object) => {
    let obj = {};
    try {
      const endpoint = this.getEndpoint(id);
      obj = await makeStripeRequest({
        url: `${account.hosts['api.stripe.com']}/v1/${endpoint}/${id}`,
        method: 'get',
        api_key: apiKey.toString(),
        raw_params: {},
        additional_headers: {},
      });
    } catch (e) {
      return {};
    }
    return obj;
  };

  // Use an asterisk as a wild card, otherwise compare the values
  static customizer(objValue: Object, expectedValue: Object) {
    if (typeof expectedValue === 'string' && expectedValue.includes('*')) {
      const prefix = expectedValue.split('*')[0];
      return objValue.startsWith(prefix);
    }

    if (typeof objValue === 'object') {
      // DFS nested object matching: call isMatchWith recursively if an object is found
      isMatchWith(objValue, expectedValue, self.customizer);
    } else {
      return objValue === expectedValue;
    }
  }

  static isMatch = (obj: Object, expected: Object) =>
    isMatchWith(obj, expected, this.customizer);
}
